"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {
            boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.4)"
        },
        editor: {
            selectors: {
                ".rating": {
                    padding: "4px 8px"
                },
                ".review": {
                    padding: "4px 8px"
                }
            }
        },
        actions: {
            padding: "4px 8px",
            selectors: {
                ".ms-Button+.ms-Button": {
                    marginLeft: 8
                }
            }
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
